export default {
  search: {
    title: '',
    youMayAlsoLike: 'You may also like',
    searchBoxTitle: 'Search for anything here...',
    searchBoxPlaceholder: 'Enter what you are searching for',
    noResults:
      "Oops! We couldn't find anything for this selection! Here are some alternatives nearby.",

    algoliaAutocomplete: {
      placeholder: 'Search for a city or event',
    },

    algoliaFederatedSearch: {
      placeholder: 'Search for a city or event',
    },
    fewResults: {
      similar: 'You may also like',
      online: 'Similar online classes',
    },

    selectLocalityComponent: {
      title: 'Where do you look for a class?',
      searchPlaceholder: 'Enter city name',
      typeHint: 'Type to see more results',
    },

    selectCategoryComponent: {
      title: 'What do you want to do?',
      searchPlaceholder: 'Enter a category name',
      typeHint: 'Type to see more results',
      numberOfResults: 'no results | one result | {n} results',
    },

    selectFiltersComponent: {
      label: 'Filters',
      showInPersonEvents: 'Show online events only',
      showEventsWithAvailableDates: 'Show only classes with available dates',
      showEventsInPreferredLanguage: 'Select preferred event language',
      price: 'Price',
    },

    selectFiltersPromotions: {
      label: 'Offers',
    },

    orderByComponent: {
      clickHint: 'Click to sort your search',
    },

    searchResults: {
      default: 'Find your class',
      results: 'Your search: {n} results',
      numberOfResults: 'no results | one result | {n} results',
      searchPageTitle: "Search: '{searchQuery}'",
      showingAdditionalResults:
        'Find here further results, related to what you are looking for.',
      theResultsAreOver: 'Check again later for more classes.',
      nResultsInCity: '{n} results in {locality}',
      nResultsOnline: '{n} results online',
      nResultsForCategory: '{n} results for {category}',
      nResultsForSearchQuery: "{n} results for '{searchQuery}'",
      nResultsEverywhere: '{n} results everywhere',
    },

    filters: {
      title: 'all filters',
      seeResults: 'See all results',
      searchAllCities: 'Search all cities',
      pricing: {
        label: 'Price',
        chipLabel: 'Price',
      },
      distance: {
        label: 'Distance',
        null: '0km',
        withinTen: 'Within 10km',
        withinFifty: 'Within 50km',
        withinHundred: 'Within 100km',
      },
      showMore: 'Show more',
      showLess: 'Show less',
      keywords: {
        label: 'Search',
        chipLabel: 'Search',
        placeholder: 'Type what you look for',
      },
      dates: {
        label: 'Dates',
        placeholder: 'Choose dates',
        selectButtonLabel: 'Select dates',
        clear: 'Clear dates',
      },
      city: {
        label: 'City',
        chipLabel: 'City',
        all: 'Search everywhere',
      },
      category: {
        label: 'Categories',
        chipLabel: 'Category',
      },
      languages: {
        label: 'Languages',
        chipLabel: 'Languages',
      },
      tag: {
        label: 'Tags',
        chipLabel: 'Tag',
      },
      minimumTickets: {
        label: 'Minimum Tickets',
        chipLabel: 'Minimum Tickets',
      },
      maximumTickets: {
        label: 'Maximum Tickets',
        chipLabel: 'Maximum Tickets',
      },

      hasAvailableDates: {
        label: 'Classes scheduled',
      },
      online: {
        label: 'Show online classes',
        chipLabel: 'online classes',
      },
      resetAll: 'Reset All',
      calendarLabel: 'What dates do you look for?',
      classType: 'Type of class',
      publicTickets: 'Public tickets',
      privateGroups: 'Private groups',
      onlineEvents: 'Online events',
      categories: '{n} categories',
      peopleAmount: 'For {n} people',
      peopleAmountLabel: 'Participants',
    },

    buttons: {
      clearAll: 'Clear All',
      clearCalendar: 'Reset calendar',
      filter: 'Filter',
      confirm: 'Show Classes',
      cancel: 'Cancel',
    },

    callToAction: {
      buttonTitle: 'Sign up to our newsletter',
      title: 'Sign up',
      relativePath: '/team-event',
      text: 'Stay up to date about new classes and promotions. Unsubscribe at any time.',
    },
  },
}
